import { getApiUrl } from "@/lib/api-config";

export interface ContactInquiryPayload {
  name: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
}

export interface ContactInquiryResponse {
  success: boolean;
  message: string;
  data?: {
    id: number;
    name: string;
    email: string;
    phone: string;
    subject: string;
    message: string;
    created_at?: string;
  };
  errors?: Record<string, string[]>;
}

/**
 * Submits a contact inquiry to the backend API.
 */
export async function submitContactInquiry(
  payload: ContactInquiryPayload
): Promise<ContactInquiryResponse> {
  const url = getApiUrl("/api/v1/web/contact-inquiries");

  try {
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    });

    const json = await res.json().catch(() => null);

    if (!res.ok) {
      // Laravel validation errors format: { message: "...", errors: { field: ["error"] } }
      let errorMessage =
        json?.message || "Failed to submit inquiry. Please try again.";

      if (json?.errors && typeof json.errors === "object") {
        const firstErrorKey = Object.keys(json.errors)[0];
        if (firstErrorKey && Array.isArray(json.errors[firstErrorKey])) {
          errorMessage = json.errors[firstErrorKey][0] || errorMessage;
        }
      }

      return {
        success: false,
        message: errorMessage,
        errors: json?.errors,
      };
    }

    return {
      success: true,
      message:
        json?.message ||
        "Your message has been sent successfully. Our support team will get in touch with you shortly.",
      data: json?.data,
    };
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.message ||
        "A network error occurred while submitting your message. Please check your connection and try again.",
    };
  }
}
